import { render } from "./Pills.vue?vue&type=template&id=22821d07"
import script from "./Pills.vue?vue&type=script&lang=js"
export * from "./Pills.vue?vue&type=script&lang=js"

import "./Pills.vue?vue&type=style&index=0&id=22821d07&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__